import styled from 'styled-components/macro';

export const CalendarListBlockItemContainer = styled.div`
  margin-bottom: 1.2rem;
`;

CalendarListBlockItemContainer.propTypes = {};
